// extracted by mini-css-extract-plugin
module.exports = {"NavigationItem":"NavigationItem_NavigationItem__1Y_Xs","active":"NavigationItem_active__RBzmX"};